// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  redirect_uri: window.location.origin,
  // api_url: window.location.origin.includes('localhost') ? 'http://dev-viagem-reembolso.apps.ap0.pr.sebrae.com.br/api/' : window.location.origin + '/api/',
    api_url: window.location.origin.includes('localhost') ? 'http://localhost:8080/api/' : window.location.origin + '/api/',

};
